import { useRef } from "react";
import Barcode from "./Barcode";
// import { gsap } from "gsap";
import Noise from "./Noise";
import Theme from "./Theme";

export default function Ticket({ ticket }) {
  const ticketRef = useRef();
  const [main, ...supports] = ticket.acts;

  // wait until DOM has been rendered
  // useEffect(() => {
  //   gsap.to(ticketRef.current, { rotation: "+=360" });
  // });

  return (
    <div
      ref={ticketRef}
      className="relative overflow-hidden grid grid-cols-10 border rounded-sm bg-cover max-w-lg min-h-[15rem] mx-auto font-mono"
      style={{
        backgroundImage:
          "url('https://img.freepik.com/free-photo/paper-texture_1194-6010.jpg?t=st=1653144679~exp=1653145279~hmac=26b5c546e4a42fa6acdad4d4f7ed3618ff01f6f0720aa158b7c55d217ad02e8d&w=1800')",
      }}
    >
      <Theme ticket={ticket} />

      <div className="col-span-8 flex flex-col justify-center p-4 pb-2 text-center">
        <p className="text-3xl font-bold mb-3">{main}</p>

        {supports.length > 0 && (
          <p className="text-lg mb-3">plus special guests</p>
        )}

        <p className="flex flex-wrap text-xl justify-center space-x-1">
          {supports.map((support, i) => (
            <span className="font-bold" key={support}>
              {support}
              {i !== supports.length - 1 && ","}
            </span>
          ))}
        </p>

        <footer className="pt-8 flex justify-between mt-auto">
          <span>{ticket.venue.name}</span>
          <span>{ticket.date}</span>
        </footer>
      </div>

      <div className="border-l-2 relative flex flex-col items-center justify-center border-gray-500 border-dashed">
        <Barcode ticket={ticket} />

        <div className="absolute bottom-1 left-1 text-xs leading-none">
          <p>Ticket</p>
          <p>x1</p>
        </div>
      </div>

      <Noise />
    </div>
  );
}
